export interface Category {
  name: string;
  href: string;
  icon: string;
  imageSeq: string;
}

export const categories: Category[] = [
  {
    name: 'Shoes',
    href: 'https://kaspreadsheet.com/category-911-Shoes.html',
    icon: 'ri-footprint-line',
    imageSeq: 'cat-shoes',
  },
  {
    name: 'Hoodies/Sweaters',
    href: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    icon: 'ri-t-shirt-line',
    imageSeq: 'cat-hoodies',
  },
  {
    name: 'T-Shirts',
    href: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    icon: 'ri-t-shirt-line',
    imageSeq: 'cat-tshirts',
  },
  {
    name: 'Jackets',
    href: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    icon: 'ri-shirt-line',
    imageSeq: 'cat-jackets',
  },
  {
    name: 'Pants/Shorts',
    href: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    icon: 'ri-pantone-line',
    imageSeq: 'cat-pants',
  },
  {
    name: 'Headwear',
    href: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    icon: 'ri-customer-service-2-line',
    imageSeq: 'cat-headwear',
  },
  {
    name: 'Sets',
    href: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    icon: 'ri-stack-line',
    imageSeq: 'cat-sets',
  },
  {
    name: 'Underwear/Underpants',
    href: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    icon: 'ri-user-line',
    imageSeq: 'cat-underwear',
  },
  {
    name: 'Jersey',
    href: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    icon: 'ri-basketball-line',
    imageSeq: 'cat-jersey',
  },
  {
    name: 'Accessories',
    href: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    icon: 'ri-vip-diamond-line',
    imageSeq: 'cat-accessories',
  },
  {
    name: 'Bags',
    href: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    icon: 'ri-briefcase-line',
    imageSeq: 'cat-bags',
  },
  {
    name: 'Belts',
    href: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    icon: 'ri-link',
    imageSeq: 'cat-belts',
  },
  {
    name: 'Perfumes',
    href: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    icon: 'ri-drop-line',
    imageSeq: 'cat-perfumes',
  },
  {
    name: 'Other Stuff',
    href: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    icon: 'ri-more-line',
    imageSeq: 'cat-other',
  },
];

export const mainSiteUrl = 'https://kaspreadsheet.com';